import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"

export const FooterWrapper = styled.footer`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 30px;

  ${media.lessThan("md")`
        background-color: var(--dark) !important; 
        margin-top: -2px;
    `}
`

export const FooterBrand = styled(Img)`
  width: 140px;
  margin-bottom: 15px;

  ${media.lessThan("md")`
        width: 120px;
    `}

  img {
    object-fit: contain !important;
  }
`

export const FooterCopy = styled.p`
  font-weight: 300;
  font-size: 14px;
  line-height: 1.3;
  text-align: center;
  color: #fff;

  ${media.lessThan("md")`
      font-size: 12px;
   `}
`
